
export default class Passenger {
  name: string = '';
  email: string = '';
  phoneCountryCode: string = '886';
  phoneNumber: string = '';
  // identityNumber = ""

  constructor(data: Partial<Passenger> = {}) {
    Object.assign(this, data);
  }

  get isEmpty(): boolean {
    return !this.name && !this.email && !this.phoneNumber; // && !this.identityNumber
  }

  get isValid(): boolean {
    return Boolean(this.name && this.email && this.phoneNumber); //&& this.identityNumber)
  }

  clone(): Passenger {
    return new Passenger(this);
  }
}